import { Card, styled } from '@grupoboticario/flora-react';

export const styles = {
  InfoCard: styled(Card, {
    backgroundColor: '$backgroundTertiary',
    padding: '$4',
    marginTop: '$4',
    width: '100%',

    '&::before': {
      boxShadow: 'initial',
    },
  }),
};

export default styles;
